import { useState } from "react";

const getInitials = (name) => {
  const safeName = (name || "").trim();
  if (!safeName) return "VK";
  const parts = safeName.split(/\s+/).filter(Boolean);
  const letters = parts.slice(0, 2).map((part) => part[0].toUpperCase());
  return letters.join("") || "VK";
};

export default function AvatarCircle({
  src,
  name,
  className = "h-8 w-8",
  textClassName = "text-xs",
  fallback = "VK",
}) {
  const [hasError, setHasError] = useState(false);
  const initials = getInitials(name || fallback);
  const showImage = src && !hasError;

  if (showImage) {
    return (
      <img
        src={src}
        alt="Profile"
        className={`rounded-full object-cover ${className}`}
        onError={() => setHasError(true)}
      />
    );
  }

  return (
    <div
      className={`rounded-full bg-black text-white flex items-center justify-center font-semibold ${className}`}
      aria-label="Profile"
    >
      <span className={textClassName}>{initials}</span>
    </div>
  );
}
